import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { connect } from 'react-redux';
import { Modal, Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import store from '../../store/store';
import Step3 from './Step3/step3';
import RecRecommend from './RecRecommend/recRecommend';
import HTTP from '../../script/service';
import {
  _get_user_info,
  _is_show_perfect,
  _show_coupon_modal,
} from '../../store/Action';
import Step1 from './Step1/step1';
import Step2 from './Step2/step2';
import { DDLoading } from '../globalPageStatus';
import './perfectModal.scss';

/**
 * 注册成功完善用户信息
 */
class index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      isUpload: false, // 是否在上传图片
      stepIndex: 0, // 步骤对应的 index

      nickName: '', // 用户呢称
      avatarUrl: '', // 头像 URL
      selectAvatarUri: null, // 当前选中的头像
      sex: null, //  性别 0:男 1:女
      birthday: null, // 生日
      nextStatus: true, // 下一步按钮状态
      // nextStatusText: "开始语音派对吧", // 下一步按钮文字
      nextStatusText: '下一步', // 下一步按钮文字

      cateList: [], // 品类列表
      cateCheckList: [], // 品类多选列表

      // 调试代码
      avatarList: [], // 当前头像列表
      manAvatarList: [], // 男头像列表
      wManAvatarList: [], // 女头像列表
    };

    this.recommendRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { step_visible, stepInfo, register } = this.props.base;
    const new_step_visible = prevProps.base.step_visible;

    if (step_visible && new_step_visible !== step_visible) {
      this.setState({ loading: false });
      setTimeout(() => {
        /*初始化轮播*/
        const index = (stepInfo && stepInfo.index) || 0;
        // const index = 1;
        this.setState({ stepIndex: index });

        const nickName =
          (register !== 3 && stepInfo && stepInfo.nickName) || '';
        this.setState({ stepIndex: index, nickName });

        if (index === 0) {
          // 步骤一
          this.setState({ loading: false });
          this.nextBtnStatus(true);
        } else if (index === 1) {
          // 步骤二
          this.step2Ref.initStep2Data();
          this.setState({ loading: false });
          this.nextBtnStatus(true, '完成');
        } else if (index === 2) {
          // 步骤二
          this.getAllCateGory();
          this.nextBtnStatus(true, '至少选择1个');
        }
      }, 500);
    }
  }

  /**
   * 关闭弹窗
   * isShow 是否展示完善资料提示的展示
   * */
  closeStepVisible = (isShow = true) => {
    const { stepInfo } = this.props.base;
    this.setState({
      cateList: [],
      cateCheckList: [],
    });

    const action = {
      type: 'hide_step_modal',
      data: { step_visible: false },
    };
    store.dispatch(action);
    // 展示新手礼包弹窗
    if (isShow && stepInfo && stepInfo.isNew) {
      _show_coupon_modal();
    }

    if (isShow) {
      store.dispatch({
        type: 'set_is_show_perfect',
        data: { isShowPerfect: true },
      });
    } else {
      // 下一步展示红人推荐
      _is_show_perfect(true);
    }
  };
  // 下一步，上一步
  handleStepControl = (bool = false) => {
    this.setState({ loading: true }, () => {
      const { stepIndex } = this.state;

      if (!bool) {
        if (stepIndex < 5) {
          switch (stepIndex) {
            case 0: // 个人信息完善
              const step1Param = this.step1Ref.getState();
              this.nextBtnStatus(true, '完成');
              this.slideNext();
              this.setState({ loading: false, ...step1Param }, () => {
                this.step2Ref.initStep2Data(this.state.sex);
              });
              break;
            case 1: // 需要的类别选择
              const step2Param = this.step2Ref.getState();
              this.setState(step2Param, () => {
                this.handleStep1Submit(() => {
                  _get_user_info({ qKey: 'perfectModal' });
                  this.getAllCateGory();

                  /* 初始化内容 */
                  this.setState({
                    nickName: '', // 用户呢称
                    avatarUrl: '', // 头像 URL
                    sex: null, //  性别 0:男 1:女
                    birthday: null, // 生日
                  });
                  /* 初始化内容 */

                  this.nextBtnStatus(true, '至少选择1个');
                });
              });
              break;
            case 2: // 需要的类别选择
              this.handleStep3Submit(() => {
                this.closeStepVisible(false);
                this.recommendRef.openCloseModal(true);
              });
              break;
            default:
              // no more
              break;
          }
        }
      }
    });
  };
  nextBtnStatus = (nextStatus = false, nextStatusText = '下一步') => {
    this.setState({ nextStatus, nextStatusText });
  };
  // 下一步
  slideNext = () => {
    this.setState({ stepIndex: this.state.stepIndex + 1 });
  };
  changeStep2 = (list) => {
    this.setState({ cateCheckList: list });
  };
  // -------------------------------------
  // 第一步提交
  handleStep1Submit = (callback = null) => {
    // this.props.setLoading(true);
    this.setState({ loading: true });
    const { nickName, birthday, sex, avatarUrl } = this.state;
    const { base } = this.props;

    if (nickName.length > 12) {
      message.warning('昵称最多包含12个字符');
      this.setState({ loading: false });
      return;
    }

    const params = {
      uid: base.uid,
      avatar: avatarUrl,
      sex,
      nickName,
      birthDate: birthday,
    };
    HTTP._set_user_config(params)
      .then((res) => {
        if (res && res.code === 200) {
          // 通知父组件 进行下一步
          this.slideNext();
          callback && callback();
        } else {
          message.error((res && res.message) || '保存失败，请稍候重试');
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  // 获取品类列表
  getAllCateGory = () => {
    const { cateList } = this.state;

    if (!cateList.length) {
      this.setState({ loading: true }, () => {
        HTTP._get_all_category()
          .then((res) => {
            if (res && res.code === 200) {
              this.setState({ cateList: res.data });
            } else {
              Modal.message.error(
                (res && res.message) || '获取失败，请稍候重试'
              );
            }
            this.setState({ loading: false });
          })
          .catch((err) => {
            this.setState({ loading: false });
          });
      });
    }
  };
  handleStep3Submit = (callback = null) => {
    const { cateCheckList } = this.state;
    const { base } = this.props;
    if (cateCheckList && cateCheckList.length) {
      const params = {
        uid: base.uid,
        categoryId: cateCheckList.join(),
      };
      HTTP._get_update_step_four(params).then((res) => {
        if (res && res.code === 200) {
          // todo 最后一步，结束
          callback && callback();
        } else {
          message.error((res && res.message) || '保存失败，请稍候重试');
        }
        this.setState({ loading: false });
      });
    } else {
      message.info('至少选择1个');
      this.setState({ loading: false });
    }
  };

  render() {
    const { step_visible } = this.props.base;
    const {
      stepIndex,
      loading,
      nextStatus,
      nextStatusText,
      cateList,
      cateCheckList,
    } = this.state;

    return (
      <>
        <Modal
          open={step_visible}
          wrapClassName="daidai-modal-style perfect-wrapper"
          footer={
            <>
              <div className="sp-parent">
                <Spin
                  spinning={loading}
                  wrapperClassName="next"
                  indicator={<LoadingOutlined />}
                >
                  <button
                    className="daidai-btn-primary"
                    disabled={nextStatus}
                    onClick={() => this.handleStepControl(false)}
                  >
                    {nextStatusText}
                  </button>
                </Spin>
              </div>
            </>
          }
          closable={stepIndex > 1}
          centered
          width={770}
          height={500}
          maskClosable={false}
          keyboard={false}
          closeIcon={<i className="custom-modal-close" />}
          onCancel={() => this.closeStepVisible()}
        >
          <DDLoading status={loading}>
            <div className="swiper-slide-wrap">
              <div
                className="swiper-slide-box"
                style={{ transform: `translateX(-${770 * stepIndex}px)` }}
              >
                <div className="swiper-slide-item">
                  <Step1
                    wrappedComponentRef={(el) => (this.step1Ref = el)}
                    nextBtnStatus={this.nextBtnStatus}
                  />
                </div>
                <div className="swiper-slide-item">
                  <Step2
                    wrappedComponentRef={(el) => (this.step2Ref = el)}
                    nextBtnStatus={this.nextBtnStatus}
                  />
                </div>
                <div className="swiper-slide-item">
                  <Step3
                    wrappedComponentRef={(el) => (this.step3Ref = el)}
                    cateList={cateList}
                    checkList={cateCheckList}
                    change={this.changeStep2}
                    nextBtnStatus={this.nextBtnStatus}
                  />
                </div>
              </div>
            </div>
          </DDLoading>
        </Modal>
        {/* 红人推荐 */}
        <RecRecommend
          wrappedComponentRef={(el) => (this.recommendRef = el)}
          base={this.props.base}
        />
      </>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(index, { withRef: true })
);
